var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeeklySpecials = function SvgWeeklySpecials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.777 0a1.2 1.2 0 0 1 1.205 1.2v2h8.036v-2A1.2 1.2 0 0 1 17.223 0a1.2 1.2 0 0 1 1.206 1.2v2h1.607a3.21 3.21 0 0 1 3.214 3.2v14.4a3.21 3.21 0 0 1-3.214 3.2H3.964A3.21 3.21 0 0 1 .75 20.8V6.4a3.21 3.21 0 0 1 3.214-3.2h1.607v-2A1.2 1.2 0 0 1 6.777 0m0 5.6H3.964a.804.804 0 0 0-.803.8v2.4h17.678V6.4c0-.44-.361-.8-.803-.8zM3.16 11.2v9.6c0 .44.361.8.803.8h16.072c.442 0 .803-.36.803-.8v-9.6z"
  })));
};
export default SvgWeeklySpecials;